import { CustomContentProps } from 'notistack'
import React from 'react'
import { styled } from '../../lib/stitches'
import { Flex } from '../core/Flex'
import { InfoIcon } from '../core/icons'
import Text from '../core/Text/Text'

export const SnackContainer = styled(Flex, {
  position: 'absolute',
  bottom: '20px',
  padding: '6px 16px',
  paddingLeft: '20px',
  borderRadius: '4px',
  alignItems: 'center',
  flexWrap: 'wrap',
  flexGrow: 1,
  width: '100%',
  boxShadow:
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)'
})

export const ModalInfoSnack = React.forwardRef<HTMLDivElement, CustomContentProps>(
  (props: CustomContentProps, ref) => {
    const { message } = props

    return (
      <SnackContainer
        css={{
          backgroundColor: '#2196f3'
        }}
        ref={ref}
      >
        <Flex css={{ padding: '8px 0px', alignItems: 'center' }}>
          <InfoIcon
            width={'1em'}
            height={'1em'}
            fill={'#FFFFFF'}
            style={{
              fontSize: '20px',
              marginInlineEnd: '8px',
              userSelect: 'none',
              display: 'inline-block',
              flexShrink: 0
            }}
          />
          <Text type={'primary_inverted'} size={'14'}>
            {message}
          </Text>
        </Flex>
      </SnackContainer>
    )
  }
)
